<template>
    <v-dialog v-model="open" width="25%" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title v-if="$root.isTouch">
                <v-spacer></v-spacer>
                <v-btn icon @click="onClose(tipo == 2 ? true : false)">
                    <v-icon color="primary">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container fluid grid-list-sm v-if="tipo == 1">
                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <v-row dense align="center" justify="center">
                                <v-img src="@/assets/img/cancelacion/lamentamosQueTeVayas.png" contain height="100"
                                    max-height="100"></v-img>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <div class="text-center mt-3">
                                <p>
                                    Lamentamos que te vayas.<br/>
                                    ¿Estás seguro que quieres continuar?
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="6">
                            <v-btn outlined dense rounded color="secondary" @click="onClose(false)" class="mr-1">Mejor No
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="6">
                            <v-btn rounded dark color="primary" @click="cancelacion(obModal)">Continuar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container fluid grid-list-sm v-else>
                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <v-row dense align="center" justify="center">
                                <v-img src="@/assets/img/cancelacion/queBuenoQueNoTeVas.png" contain height="100"
                                    max-height="100"></v-img>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <div class="text-center mt-3">
                                <p>
                                    Nos gusta ayudarte a estar seguro. <br/>
                                    Siéntete libre de volver aquí cuando quieras.
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row dense align="center" justify="center">
                        <v-col cols="5" sm="5">
                            <v-btn outlined dense rounded color="secondary" @click="onClose(true)">Gracias</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalConfirmacionCancelacionComponent',
        inject:['onClose','cancelacion'],
        props:{
            open:{
                type:Boolean,
                default:false
            },
            tipo:{
                type:Number,
                default:1
            },
            obModal:{
                type:Object,
                default:{}
            }
        }
    }
</script>